module.exports = __webpack_public_path__ + "fonts/IvarDisplay-MediumItalic.ttf";